import React, { useState } from 'react';
import Icon from '../IconBase/Icon';

const MobileNavigationLanguageSwitcher = ({
  currentChannel,
  otherChannels,
}) => {
  const [selectorActive, setSelectorActive] = useState(false);
  const toggleSelector = () => {
    setSelectorActive(!selectorActive);
  };

  return (
    <div
      className={`mobile-nav-language-switcher ${
        selectorActive ? 'mobile-nav-language-switcher--active' : ''
      }`}
    >
      <div
        className="mobile-nav-language-switcher__channel"
        onClick={() => toggleSelector()}
      >
        {currentChannel.flagUrl && (
          <img
            className="mobile-nav-language-switcher__channel-flag"
            src={currentChannel.flagUrl}
          />
        )}
        <span className="mobile-nav-language-switcher__channel-name">
          {currentChannel.name}
        </span>
        <Icon iconCode="expand_more" />
      </div>
      <div className="mobile-nav-language-switcher__selector">
        {otherChannels?.length > 0 &&
          otherChannels.map((otherChannel) => (
            <a
              className="mobile-nav-language-switcher__channel"
              href={otherChannel.url}
              key={otherChannel.name}
            >
              {otherChannel.flagUrl && (
                <img
                  className="mobile-nav-language-switcher__channel-flag"
                  src={otherChannel.flagUrl}
                />
              )}
              <span className="mobile-nav-language-switcher__channel-name">
                {otherChannel.name}
              </span>
            </a>
          ))}
      </div>
    </div>
  );
};

export default MobileNavigationLanguageSwitcher;
